export default function NoticeSection() {
  return (
    <section id="notice" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-8">
            Important Notice
          </h2>
          <div className="bg-white border border-background-200/70 rounded-lg p-6 md:p-8 text-left space-y-4">
            <div className="flex items-start gap-3">
              <i className="ri-information-line text-accent-500 text-lg mt-0.5 flex-shrink-0"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">
                This website provides informational spreadsheet data only. We do not directly sell or ship any products.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-information-line text-accent-500 text-lg mt-0.5 flex-shrink-0"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">
                Users are responsible for verifying external sources before making purchasing or sourcing decisions.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-information-line text-accent-500 text-lg mt-0.5 flex-shrink-0"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">
                Data is for research and educational use only. Market conditions can change rapidly and past trends do not guarantee future results.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}